import React from 'react'
import { useState, useContext, useMemo, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Context } from '../../App';
import { db } from '../../config/firebase'
import {
  setDoc,
  doc,
  Timestamp,
} from "firebase/firestore";

import { CiLock } from "react-icons/ci";
import { CiUnlock } from "react-icons/ci";
import { FcGoogle } from "react-icons/fc";
import ReactGA from "react-ga4";
import { PiIdentificationCardLight } from "react-icons/pi";
import { MdOutlineDriveFileRenameOutline } from "react-icons/md";
import { HiOutlineIdentification } from "react-icons/hi2";
import { VscWholeWord } from "react-icons/vsc";
import { RiLockPasswordLine } from "react-icons/ri";
import { CiRead, CiUnread } from "react-icons/ci";

import Spinner from '../../components/Loading/TailSpin';
import Checkbox from '../../components/Input/Checkbox';
import { SiTrueup } from 'react-icons/si';


function AddUser({  }) {
  const navigate = useNavigate();

  const {
    generatedCodeC,
    nameC, } = useContext(Context);

  let generatedUserPassword = useMemo(() => {
    let intermCode = "";
    for (let i = 0; i < 8; i++) {
      intermCode += ('ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'.charAt(Math.floor(Math.random() * 62)))
    }
    // console.log(intermCode);
    return intermCode
  }, [])

  const [generatedCode, setGeneratedQrCode] = generatedCodeC
  const [name, setName] = nameC;

  const [isLoading, setIsloading] = useState(false);
  const [displayName, setDisplayName] = useState("");
  const [profile, setProfile] = useState("");
  const [password, setPassword] = useState(generatedUserPassword);
  const [isAnonymous, setIsAnonymous] = useState(false);

  const [canEditName, setCanEditName] = useState(false);
  const [canEditsetProfile, setCanEditsetProfile] = useState(false);
  const [canEditsetDisplayName, setCanEditsetDisplayName] = useState(false);
  const [canEditsetPassword, setCanEditsetPassword] = useState(false);
  const [canEditsetIsAnonymous, setCanEditsetIsAnonymous] = useState(false);

  const modeSelectionTab = [
    {
      name: "Public",
      icon: <CiRead className="w-full h-full" />,
    },
    {
      name: "Anonymous",
      icon: <CiUnread className="w-full h-full" />,
    },
  ]

  const [currModeSelectionTab, setCurrModeSelectionTab] = useState(0);

  let generatedUserId = useMemo(() => {
    let intermCode = "";
    for (let i = 0; i < 6; i++) {
      intermCode += ('ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'.charAt(Math.floor(Math.random() * 62)))
    }
    setGeneratedQrCode(intermCode);
    // console.log(intermCode);
    return intermCode
  }, [])


  // ===================| MAIN PUSH |=================================================
  const handleAddUser = async () => {
    setIsloading(true);
    const enteredData = {
      name,
      displayName,
      profile,
      password,
      createdAt: Timestamp.now(),
      groups: [],
      accessStatus: 1,
      isAnonymous,
      canEditName,
      canEditsetProfile,
      canEditsetDisplayName,
      canEditsetPassword,
      canEditsetIsAnonymous,
    }

    ReactGA.event({
      category: "Admin",
      action: "Add User",
      label: localStorage.getItem("displayName"),
      value: name,
    });

    try {
      const docRef = doc(db, 'users', generatedUserId);

      await setDoc(docRef, enteredData);
      navigate('/GURU/add-user/code');
    } catch (error) {
      // console.error("Error adding document: ", error);
    }
    setIsloading(false);
  };

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: "GURU/add-user", title: "Add User" })
  }, [])

  if (!isLoading)
    return (
      <div className='w-full h-full flex flex-col items-center justify-center p-6'>

        <div className="w-full md:w-[450px] p-6  bg-lightPrimary flex flex-col items-center rounded-lg ">
          <div className="text-3xl font-semibold text-headPrimary">Add User</div>

          <div className="w-full grid grid-cols-1 gap-4 mt-7">

            <div className="flex w-full items-center justify-between gap-3">
              <div className="flex justify-start w-full ">
                <div className="border border-gray-300 bg-white text-gray-700 dark:bg-navy-900 dark:text-white z-1 flex h-[40px] md:h-[42px] w-full flex-grow items-left justify-start gap-2 rounded-md px-2.5 py-2.5 shadow-xl shadow-shadow-500 dark:!bg-navy-800 dark:shadow-none md:flex-grow-0 md:gap-1 xl:gap-2 w-full">
                  <div className="flex h-full w-full items-center font-normal ">
                    <VscWholeWord
                      className="h-4 w-4 text-gray-400 hover:text-headPrimary cursor-pointer dark:text-white" />
                    <input
                      onChange={(e) => {
                        setName((e.target.value))
                      }}
                      value={name}
                      type="text"
                      placeholder="Full Name"
                      className="block ml-0 px-2 h-auto w-full rounded-full bg-white text-lg text-gray-700 outline-none placeholder:!text-gray-400 dark:bg-navy-900 dark:text-white dark:placeholder:!text-white"
                    />
                  </div>

                </div>
              </div>

              <div onClick={() => { setCanEditName((prev) => !prev) }} className="cursor-pointer">
                {canEditName ?
                  <CiUnlock className='w-6 h-6 text-gray-600 hover:text-our-600' />
                  :
                  <CiLock className='w-6 h-6 text-headPrimary hover:text-our-600' />
                }
              </div>
            </div>

            <div className="flex w-full items-center justify-between gap-3">

              <div className="flex justify-start w-full">
                <div className="border border-gray-300 bg-white text-gray-700 dark:bg-navy-900 dark:text-white z-1 flex h-[40px] md:h-[42px] w-full flex-grow items-left justify-start gap-2 rounded-md px-2.5 py-2.5 shadow-xl shadow-shadow-500 dark:!bg-navy-800 dark:shadow-none md:flex-grow-0 md:gap-1 xl:gap-2 w-full">
                  <div className="flex h-full w-full items-center font-normal ">
                    <MdOutlineDriveFileRenameOutline
                      className="h-4 w-4 text-gray-400 hover:text-headPrimary cursor-pointer dark:text-white" />
                    <input
                      onChange={(e) => {
                        setProfile((e.target.value))
                      }}
                      value={profile}
                      type="text"
                      placeholder="Role"
                      className="block ml-0 px-2 h-auto w-full rounded-full bg-white text-lg text-gray-700 outline-none placeholder:!text-gray-400 dark:bg-navy-900 dark:text-white dark:placeholder:!text-white"
                    />
                  </div>

                </div>
              </div>

              <div onClick={() => { setCanEditsetProfile((prev) => !prev) }} className="cursor-pointer">
                {canEditsetProfile ?
                  <CiUnlock className='w-6 h-6 text-gray-600 hover:text-our-600' />
                  :
                  <CiLock className='w-6 h-6 text-headPrimary hover:text-our-600' />
                }
              </div>
            </div>

            <div className="flex w-full items-center justify-between gap-3">

              <div className="flex justify-start w-full w-[calc(100%-110px)]">
                <div className="border border-gray-300 bg-white text-gray-700 dark:bg-navy-900 dark:text-white z-1 flex h-[40px] md:h-[42px] w-full flex-grow items-left justify-start gap-2 rounded-md px-2.5 py-2.5 shadow-xl shadow-shadow-500 dark:!bg-navy-800 dark:shadow-none md:flex-grow-0 md:gap-1 xl:gap-2 w-full">
                  <div className="flex h-full w-full items-center font-normal ">
                    <PiIdentificationCardLight
                      className="h-4 w-4 text-gray-400 hover:text-headPrimary cursor-pointer dark:text-white" />
                    <input
                      onChange={(e) => {
                        setDisplayName((e.target.value))
                      }}
                      value={displayName}
                      type="text"
                      placeholder="Display Name"
                      className="block ml-0 px-2 h-auto w-full rounded-full bg-white text-lg text-gray-700 outline-none placeholder:!text-gray-400 dark:bg-navy-900 dark:text-white dark:placeholder:!text-white"
                    />
                  </div>

                </div>
              </div>
              <div onClick={() => { setCanEditsetDisplayName((prev) => !prev) }} className="cursor-pointer">
                {canEditsetDisplayName ?
                  <CiUnlock className='w-6 h-6 text-gray-600 hover:text-our-600' />
                  :
                  <CiLock className='w-6 h-6 text-headPrimary hover:text-our-600' />
                }
              </div>
            </div>

            <div className="flex w-full items-center justify-between gap-3">

              <div className="flex justify-start w-full w-[calc(100%-110px)]">
                <div className="border border-gray-300 bg-white text-gray-700 dark:bg-navy-900 dark:text-white z-1 flex h-[40px] md:h-[42px] w-full flex-grow items-left justify-start gap-2 rounded-md px-2.5 py-2.5 shadow-xl shadow-shadow-500 dark:!bg-navy-800 dark:shadow-none md:flex-grow-0 md:gap-1 xl:gap-2 w-full">
                  <div className="flex h-full w-full items-center font-normal ">
                    <PiIdentificationCardLight
                      className="h-4 w-4 text-gray-400 hover:text-headPrimary cursor-pointer dark:text-white" />
                    <input
                      disabled={true}
                      value={generatedUserId}
                      type="text"
                      className="block ml-0 px-2 h-auto w-full rounded-full bg-white text-lg text-gray-700 outline-none placeholder:!text-gray-400 dark:bg-navy-900 dark:text-white dark:placeholder:!text-white"
                    />
                  </div>

                </div>
              </div>
              <div onClick={() => { }} className="text-gray-600 text-headPrimary">
                <CiLock className='w-6 h-6' />
              </div>
            </div>

            <div className="flex w-full items-center justify-between gap-3">

              <div className="flex justify-start w-full w-[calc(100%-110px)]">
                <div className="border border-gray-300 bg-white text-gray-700 dark:bg-navy-900 dark:text-white z-1 flex h-[40px] md:h-[42px] w-full flex-grow items-left justify-start gap-2 rounded-md px-2.5 py-2.5 shadow-xl shadow-shadow-500 dark:!bg-navy-800 dark:shadow-none md:flex-grow-0 md:gap-1 xl:gap-2 w-full">
                  <div className="flex h-full w-full items-center font-normal ">
                    <RiLockPasswordLine
                      className="h-4 w-4 text-gray-400 hover:text-headPrimary cursor-pointer dark:text-white" />
                    <input
                      onChange={(e) => {
                        setPassword((e.target.value))
                      }}
                      value={password}
                      type="text"
                      placeholder="Password"
                      className="block ml-0 px-2 h-auto w-full rounded-full bg-white text-lg text-gray-700 outline-none placeholder:!text-gray-400 dark:bg-navy-900 dark:text-white dark:placeholder:!text-white"
                    />
                  </div>

                </div>
              </div>
              <div onClick={() => { setCanEditsetPassword((prev) => !prev) }} className="cursor-pointer">
                {canEditsetPassword ?
                  <CiUnlock className='w-6 h-6 text-gray-600 hover:text-our-600' />
                  :
                  <CiLock className='w-6 h-6 text-headPrimary hover:text-our-600' />
                }
              </div>
            </div>

            <div className="flex w-full items-center justify-between gap-3 h-[42px] ">


              <div className="w-fit p-1 rounded flex items-center justify-between gap-1 border border-gray-300 bg-white">
                {
                  modeSelectionTab.map((item, i) => (
                    <div
                      key={item.name}
                      onClick={() => { setIsAnonymous(i === 1); setCurrModeSelectionTab(i) }}
                      className={`text-base px-2  cursor-pointer rounded flex items-center justify-start btn-primary 
              ${currModeSelectionTab === i ? "text-white bg-headPrimary font-semibold py-1 min-w-[70px]" : "hover:bg-lightPrimary hover/text-headPrimary py-0.5 min-w-[60px]"}`} >
                      <div className="w-4 h-4 mr-1">{item.icon}</div>

                      <div className="">{item.name}</div>
                    </div>
                  ))
                }
              </div>

              <div onClick={() => { setCanEditsetIsAnonymous((prev) => !prev) }} className="cursor-pointer">
                {canEditsetIsAnonymous ?
                  <CiUnlock className='w-6 h-6 text-gray-600 hover:text-our-600' />
                  :
                  <CiLock className='w-6 h-6 text-headPrimary hover:text-our-600' />
                }
              </div>
            </div>

          </div>

          <button
            onClick={handleAddUser}
            className=" mt-5 flex items-center justify-center py-2 w-[100%] bg-white rounded-md border text-xl text-headPrimary hover:text-white hover:bg-headPrimary shadow-md hover:shadow-lg hover:font-bold">
            Create Account
          </button>

        </div>

      </div>
    )

  else return (<Spinner />)
}

export default AddUser